import api from './apiClient'

/**
 * `POST /users/lookup` — traduz IDs de usuário em nome e email.
 *
 * A API de produção guarda só o ID de quem criou a ordem ou é responsável; o
 * cadastro é do SSO. Sem isto, as telas exibem GUID, que não identifica
 * ninguém. Não é listagem: só resolve os IDs enviados.
 */
export const resolveUsers = async ids => {
  const response = await api.post('/users/lookup', { ids })
  return response.data ?? []
}
